__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-06-1783340526-stable-dev/";